<!-- eslint-disable vue/no-v-html -->
<script>
import BaseButton from '@/components/lavender/Button/BaseButton.vue'

export default {
  name: 'LoginResetPasswordSuccess',
  components: {
    BaseButton,
  },
  props: {
    submittedEmail: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <div class="tamara-login-reset-password-success px-5">
    <div class="tamara-login-reset-password-success__header">
      <div class="tamara-login-reset-password-success__title">
        {{ $t('forgot_password_success') }}
      </div>
      <div
        class="tamara-login-reset-password-success__description"
        v-html="$t('forgot_password_success_sub', { email: submittedEmail })"
      />
    </div>
    <div class="tamara-login-reset-password-success__body">
      <BaseButton
        class="tamara-login-reset-password-success__button w-full"
        @click="$emit('back:login')"
      >
        {{ $t('forgot_password_success_button') }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';
@import '@/styles/_breakpoints.scss';

.tamara-login-reset-password-success {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  background-color: var(--tamara-background-color-primary);
  border-radius: var(--tamara-border-radius-lg);

  &__title {
    @extend .tamara-heading-large;
  }

  &__description {
    @extend .tamara-title-small;

    margin-top: 12px;
    color: var(--tamara-color-functional-grey-dark-1);
  }

  @include breakpoints(mobile) {
    padding: 40px;
  }
}
</style>
